import StagingArea from "../staging-area";
import PickProgress from "../pick-progress";
import {PickStatus} from "../enums/pick-enums";
import ItemLocation from "../item-location";

export default class StageCartResponse {
    constructor() {
        this.cartLabel = "cartLabel";
        this.stagingArea = new StagingArea();
        this.pickProgress = new PickProgress();
        this.pickStatus = PickStatus.COMPLETED;
        this.nonMandatoryStepSkipAckRequired = false;
        this.ackReqForLocation = new ItemLocation();
        this.attemptedStagingLocation = "STAGE-1";
    }
}


// WEBPACK FOOTER //
// ./src/models/response/stage-cart-response.js